const getters = {
    halfWidth: state => state.width / 2,
    halfHeight: state => state.height / 2,
    isMobile: state => state.isTouch && state.width < 768,
    isTablet: state => state.isTouch && state.width <= 1024,
};

export default getters;
